import React, { useEffect } from "react";
import { Form, Input, Button, Card, Typography, Row, Col, Alert } from "antd";
import {
  UserOutlined,
  LockOutlined,
  MedicineBoxOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../store";
import { loginStart, clearError } from "../../store/slices/authSlice";

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [form] = Form.useForm();
  const { loading, error, isAuthenticated } = useSelector(
    (state: RootState) => state.auth,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    // Clear any previous errors when component mounts
    dispatch(clearError());
  }, [dispatch]);

  const handleSubmit = (values: { email: string; password: string }) => {
    dispatch(loginStart(values));
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Row justify="center" style={{ width: "100%", maxWidth: 400 }}>
        <Col span={24}>
          <Card
            style={{
              borderRadius: 10,
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
            }}
            bodyStyle={{ padding: "40px 30px" }}
          >
            <div style={{ textAlign: "center", marginBottom: 30 }}>
              <MedicineBoxOutlined
                style={{
                  fontSize: 48,
                  color: "#667eea",
                  marginBottom: 16,
                }}
              />
              <Title level={2} style={{ margin: 0, color: "#333" }}>
                Pharmacy Stock Management
              </Title>
              <Text type="secondary">Sign in to your account</Text>
            </div>

            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                style={{ marginBottom: 24 }}
                closable
                onClose={() => dispatch(clearError())}
              />
            )}

            <Form
              form={form}
              name="login"
              onFinish={handleSubmit}
              layout="vertical"
              size="large"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Email"
                  autoComplete="email"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Password"
                  autoComplete="current-password"
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 16 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  style={{
                    height: 45,
                    fontSize: 16,
                    fontWeight: 500,
                  }}
                >
                  Sign In
                </Button>
              </Form.Item>
            </Form>

            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Text type="secondary">
                Need an account? Contact your platform operator.
              </Text>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
